import { render, staticRenderFns } from "./paperKnowledges.vue?vue&type=template&id=7e9a5282&scoped=true&"
import script from "./paperKnowledges.vue?vue&type=script&lang=js&"
export * from "./paperKnowledges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9a5282",
  null
  
)

export default component.exports